import { useEffect, useState } from 'react';
import { Box, Grid, Typography, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import useAnalytics from '../../hooks/useAnalytics';
import { BASKET } from '../../constants/analytics';
import { CONFIRMATION } from '../../constants/strings';
import useBreakpoint from '../../hooks/useBreakpoint';
import ParcelDisplay from '../../components/ParcelDisplay';
import getMobileOS from '../../helpers/getMobileOS';
import { DIGITAL_INFORMATION_STEPS_CONFIG } from './config';
import { StepsList } from './components/StepsList';

const DropOff = ({ barcodes, shipment, shipmentId }) => {
  const theme = useTheme();
  const [fetchedBarcodes, setFetchedBarcodes] = useState(barcodes);
  const { setInterfaceId, Trackable } = useAnalytics();
  const isSmallScreen = useBreakpoint('sm');
  const os = getMobileOS();

  useEffect(() => {
    setInterfaceId(BASKET.INTERFACE_ID);
  }, [setInterfaceId]);

  useEffect(() => {
    if (barcodes?.length) {
      setFetchedBarcodes(barcodes);
    }
  }, [barcodes]);

  return (
    <Trackable loadId={BASKET.LOAD}>
      <Grid sx={{ background: theme.vars.palette.background.paper, pb: 4 }}>
        <Grid container alignItems='center' justifyContent='center'>
          <Grid
            alignItems='center'
            justifyContent='center'
            spacing={2}
            width='100%'
            sx={{ mt: 0 }}
          >
            <Grid
              sx={{ width: '100%' }}
              size={{
                xs: 12,
                md: 12,
              }}
            >
              <Grid
                sx={{
                  mt: 1,
                  position: 'relative',
                  p: 0,
                  maxWidth: isSmallScreen ? '100vw' : '400px',
                }}
              >
                <Box sx={{ px: 2, pt: 2 }}>
                  <Typography variant='body1' sx={{ pb: 2 }}>
                    {CONFIRMATION.TITLE}
                  </Typography>
                  <StepsList config={DIGITAL_INFORMATION_STEPS_CONFIG} />
                </Box>
                <ParcelDisplay
                  barcodes={fetchedBarcodes}
                  isSmallScreen={isSmallScreen}
                  os={os}
                  shipment={shipment}
                  shipmentId={shipmentId}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Trackable>
  );
};

DropOff.propTypes = {
  shipment: PropTypes.object,
  shipmentId: PropTypes.string,
  barcodes: PropTypes.array,
};

export default DropOff;
